import React from "react"
import { OrderPaymentQliroOne } from "lib/types/generated/graphql-types"
import {
  getPaymentMethodDisplayName
} from "helpers/getPaymentDisplayName"
import { Container, Label, LogoWrapper, Row, StatusWrapper } from "./Styled"
import ListEntry from "../../../../../components/Order/Ui/ListEntry"
import StatusSmall from "../../../../../components/Ui/Status/StatusSmall"
import { getProviderLogo } from "helpers/providers"

type Props = {
  orderPayment: OrderPaymentQliroOne
}

const QliroOne = ({ orderPayment }: Props) => {
  if (!orderPayment) return null

  return (
    <>
      <Container>
        <Row>
          <ListEntry
            label={"Payment provider"}
            value={<LogoWrapper>{getProviderLogo(orderPayment.providerName)}</LogoWrapper>}
          />{" "}
          <ListEntry
            label={"Payment method"}
            value={getPaymentMethodDisplayName(orderPayment.method)}
          />
          <ListEntry label={"Payment reference"} value={orderPayment.reference} />
          {orderPayment?.paymentTypeCode && (
            <ListEntry label={"Payment type code"} value={orderPayment.paymentTypeCode} />
          )}
        </Row>
      </Container>
      <Container>
        <Row>
          <div>
            <Label>Payment status</Label>
            <StatusWrapper>
              <StatusSmall status={orderPayment.status.toUpperCase()} />
            </StatusWrapper>
          </div>
          {orderPayment?.upsell && (
            <div>
              <Label>Upsell status</Label>
              <StatusSmall status={orderPayment?.upsell?.status} />
            </div>
          )}
          <div>
            <Label>Identity</Label>
            <StatusWrapper>
              <StatusSmall status={orderPayment.identityVerified ? "Verified" : "Not verified"} />
            </StatusWrapper>
          </div>
          <div>
            <Label>Merchant question answer:</Label>
            <StatusWrapper>
              <StatusSmall
                status={orderPayment.merchantProvidedQuestionAnswer ? "Provided" : "Not provided"}
              />
            </StatusWrapper>
          </div>
          <div>
            <Label>Signup for newsletter:</Label>
            <StatusWrapper>
              <StatusSmall status={orderPayment.signupForNewsletter ? "Enabled" : "Disabled"} />
            </StatusWrapper>
          </div>
        </Row>
      </Container>
      <Container>
        <Label>Order Items</Label>
        <Row>
          {orderPayment?.orderItems?.map((orderItem) => (
            <ListEntry
              label={orderItem.paymentTransactionId.toString()}
              value={orderItem.merchantReference}
            />
          ))}
        </Row>
      </Container>
    </>
  )
}

export default QliroOne
